<template>
  <div
    class="aj-input"
    :class="classObject"
    @click="setFocus"
  >
    <slot
      name="label"
      :label="label"
      :input-id="computedId"
    >
      <aj-text
        v-if="label"
        tag="label"
        body-small
        bold
        class="aj-input__label"
        :for="computedId"
      >
        {{ label }}
      </aj-text>
    </slot>
    <div class="aj-input__textField">
      <input
        :id="computedId"
        :disabled="disabled"
        v-bind="$attrs"
        v-on="listeners"
      >
      <slot name="iconLeft">
        <aj-icon
          v-if="iconLeft"
          :shape="iconLeft"
          class="aj-input__icon -left"
        />
      </slot>
      <slot name="iconRight">
        <aj-icon
          v-if="iconRight || activeClearIcon"
          :shape="rightIconShape"
          class="aj-input__icon -right"
          :class="{ '-clear': activeClearIcon }"
          @click="handleRightIconClick"
        />
      </slot>
    </div>
    <slot name="additionalContent" />
    <template v-if="errors.length">
      <aj-text
        v-for="(error, key) in errors"
        :key="key"
        body-small
        class="aj-input__error"
      >
        {{ error }}
      </aj-text>
    </template>
  </div>
</template>

<script>
import AjIcon from '../AjIcon/AjIcon.vue';
import AjText from '../AjText/AjText.vue';

let uuid = 0;

export default {
  name: 'AjInput',
  components: {
    AjIcon,
    AjText,
  },

  props: {
    label: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: null,
    },
    iconLeft: {
      type: String,
      default: '',
    },
    iconRight: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    special: {
      type: Boolean,
      default: false,
    },
    showClearIcon: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    listeners () {
      return {
        ...this.$listeners,
        input: event => this.$emit('input', event.target.value),
      };
    },

    classObject () {
      return {
        '-iconRight': !!this.iconRight,
        '-iconLeft': !!this.iconLeft,
        '-disabled': this.disabled,
        '-special': this.special,
        '-error': this.errors.length,
      };
    },

    activeClearIcon () {
      return this.showClearIcon && this.$attrs?.value?.length;
    },

    rightIconShape () {
      if (this.activeClearIcon) {
        return 'times-outline';
      }

      return this.iconRight;
    },

    computedId () {
      return this.id || `input-${this.uuid}`;
    },
  },

  beforeCreate () {
    this.uuid = uuid.toString();
    uuid += 1;
  },

  methods: {
    setFocus () {
      this.$el.getElementsByTagName('input')[0].focus();
    },

    handleRightIconClick () {
      if (this.activeClearIcon) {
        this.$emit('input', '');
      }
    },
  },
};
</script>

<style src="./AjInput.scss" lang="scss" />
